export const CustomerRoleEnum =
[
    {
        "id": "ROLE_USER",
        "name": "Customer",
        "disabled": true
    }
];

export const AdminRoleEnum =
[
    {
        "id": "ROLE_ADMIN",
        "name": "Admin"
    },
    {
        "id": "ROLE_ADMIN_SALES",
        "name": "Sales Manager"
    },
    {
        "id": "ROLE_ADMIN_MARKETING",
        "name": "Marketing Manager"
    },
    {
        "id": "ROLE_ADMIN_INVERTORY",
        "name": "Inventory Manager"
    },
    {
        "id": "ROLE_ADMIN_CUSTOMER",
        "name": "Customer Manager"
    },
];

export const RoleEnum = [...CustomerRoleEnum, ...AdminRoleEnum];
